
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter , Routes, Route} from 'react-router-dom';

import Root from './Components/Root';
import Main from './Components/ClaimsComponents/Main';
import { ReactViewAdobe } from 'react-adobe-embed';
import { clientId } from './Components/SecureMesage';

function App() {
  return (<>
   <BrowserRouter 
   
   >
  <Routes 
  
  >
    <Route path="/" element={<Root />} />

    <Route
    
    path="/manage/claims/:page" element={<Main />} />
  </Routes>

   </BrowserRouter>
   <ReactViewAdobe
     url='https://storage.googleapis.com/laotzu/awslegal/ANDYTIME/FMLA_JUNE11_L029%20-%20Approval%20-%20EOHC%20-%20EE-04073256.pdf'
     
     clientId={
      clientId()
     }


     fileMeta={{
      'fileName':'FMLA_JUNE11_L029 - Approval - EOHC - EE-04073256.pdf',

     }}
    
    id="exhibit-f-pdf"
     
     previewConfig={{
      embedMode:'LIGHT_BOX',
     }}
     
   
     />
   </>
  );
}

export default App;
